import { createFileRoute } from "@tanstack/react-router";

import { ShippingContent } from "@/features/dashboard/transportadoras/components/ShippingContent";

export const Route = createFileRoute("/_private/dashboard/_base/transportadoras/_forms/editar/$id/")({
  component: ShippingContent
});
